export default "__VITE_ASSET__BByPeCaJ__"